import { Button, Icon, IconButton, Typography } from '@mui/material';
import MDBox from 'components/MDBox';
import React from 'react'


interface PaginationProps {
    rowsPerPage: number;
    count: number;
    paginate: (_:any, pageNumber: number) => void;
    currentPageNumber: number;
}

const Pagination = ({
    rowsPerPage,
    count,
    paginate,
    currentPageNumber,
  }: PaginationProps) => {

  const pages: number[] = [];

  for (let i = 0; i <= Math.ceil(count / rowsPerPage)-1; i++) {
    pages.push(i);
  }

  return (
    <MDBox
        whiteSpace='nowrap'>
        <IconButton onClick={() => paginate(undefined,0)}><Icon>keyboard_double_arrow_left</Icon></IconButton>
        <IconButton onClick={() => paginate(undefined,Math.max(0, currentPageNumber-1))}><Icon>keyboard_arrow_left</Icon></IconButton>
        {currentPageNumber >= 2 && pages.length > 2 && (
           <IconButton style={{ cursor: 'default'}} disableRipple><Icon>more_horiz</Icon></IconButton>
        )}
        {pages.filter((pageNumber) => pageNumber >= Math.max(0, currentPageNumber-1) && pageNumber <= Math.min(currentPageNumber+1, pages[pages.length-1])).map((pageNumber) => (
            <IconButton
                sx={{
                    width: '40px',
                    backgroundColor: currentPageNumber === pageNumber ? 'primary.main' : 'transparent',
                    color: currentPageNumber === pageNumber ? 'white' : 'inherit',
                    "&:hover": {
                        backgroundColor: currentPageNumber === pageNumber ? 'primary.main' : 'transparent',
                        color: currentPageNumber === pageNumber ? 'white' : 'inherit',
                    }
                }}
                key={pageNumber}
                onClick={() => paginate(undefined, pageNumber)}>
                <Typography>{pageNumber+1}</Typography></IconButton>
        ))}
        {Math.ceil(count / rowsPerPage) - currentPageNumber >= 3 &&
        pages.length > 2 && (
            <IconButton style={{ cursor: 'default' }} disableRipple><Icon>more_horiz</Icon></IconButton>
            )}
        <IconButton onClick={() => paginate(undefined, Math.min(currentPageNumber+1, pages[pages.length-1]))}><Icon>keyboard_arrow_right</Icon></IconButton>
        <IconButton onClick={() => paginate(undefined, pages[pages.length-1])}><Icon>keyboard_double_arrow_right</Icon></IconButton>
    </MDBox>
  )
}

export default Pagination